import React, { useState, useEffect } from 'react'
import Footer from '../components/Footer/Footer'
import ReactInputVerificationCode from 'react-input-verification-code';
import SecondHeader from '../components/SecondHeader/SecondHeader';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { VerifyOtpAPI } from '../redux/slices/VerifyOTP';
import { forgotPasswordAPI } from '../redux/slices/ForgotPasswordSlice';
import { toast } from 'react-toastify';
import { errorHandler } from '../constants/base';


const EmailVarification = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleComplete = async (value) => {
        const verifyOTPData = {
            email: localStorage.getItem("forgotEmailAddress"),
            otp: value
        }
        const res = await dispatch(VerifyOtpAPI(verifyOTPData));

        // if (res?.payload?.status === 200) {
        //     toast.success("OTP Verification Successfully Done")
        //     navigate('/reset-password')
        //     localStorage.setItem("otp", verifyOTPData.otp)
        // }

        if (VerifyOtpAPI.fulfilled(res)) {
            if (res.payload.status === 200) {
                toast.success("OTP Verification Successfully Done")
                navigate('/reset-password')
                localStorage.setItem("otp", verifyOTPData.otp)
            } else {
                errorHandler(res.payload.errors);
            }
        } else if (VerifyOtpAPI.rejected(res)) {
            errorHandler(res.payload.errors);

        } else {
            toast.error('Sorry, something went wrong!');
        }
    }

    // ONE MINUTE TIMER
    const [timeLeft, setTimeLeft] = useState(() => {
        const storedTime = localStorage.getItem('otpTimer');
        if (storedTime) {
            const now = Date.now();
            const timeRemaining = Math.max(0, Number(storedTime) - now);
            return Math.ceil(timeRemaining / 1000);
        }
        return 60;
    });

    useEffect(() => {
        if (timeLeft <= 0) {
            localStorage.removeItem('otpTimer');
            return;
        }
        const expirationTime = Date.now() + timeLeft * 1000;
        localStorage.setItem('otpTimer', expirationTime);

        const interval = setInterval(() => {
            setTimeLeft((prevTime) => {
                const newTime = prevTime - 1;
                if (newTime <= 0) {
                    clearInterval(interval);
                    localStorage.removeItem('otpTimer');
                }
                return newTime;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [timeLeft]);

    const handleResendOtp = async () => {
        const emailData = {
            email: localStorage.getItem("forgotEmailAddress"),
        };
        const res = await dispatch(forgotPasswordAPI(emailData))
        if (res?.payload?.status === 200) {
            setTimeLeft(60);
        }
    };

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };
    // ONE MINUTE TIMER

    return (
        <>
            <SecondHeader />
            <div className="varificaion-box-main">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="home-banner-text">
                                <h1>Verification OTP</h1>
                                <p className="common-text">Enter the verification OTP that we have
                                    sent to your email</p>
                            </div>

                            <div className="varification-code-boxes">
                                <ReactInputVerificationCode placeholder='' style={{
                                    borderColor: "#5658f6",
                                }} onCompleted={handleComplete} />
                            </div>

                            {/* <h1 className='resend-otp-text'>
                                Resend OTP in {formatTime(timeLeft)}
                            </h1> */}

                            <div className='resend-otp-container'>
                                {timeLeft > 0 ? (
                                    <h1 className='resend-otp-text'>
                                        Resend OTP in {formatTime(timeLeft)}
                                    </h1>
                                ) : (
                                    <div className="submit-btn-form mt-4">
                                        <button className="btn btn-primary" onClick={handleResendOtp}>Resend OTP</button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default EmailVarification